import "./styles.scss";

import React from "react";
import { Link } from "gatsby";

const links = [
  {
    label: "Psycholog Warszawa",
    url: "/psycholog-warszawa/",
    isBlank: true,
  },
  {
    label: "Psycholog Warszawa Białołęka",
    url: "/psycholog-warszawa-bialoleka/",
    isBlank: true,
  },
  {
    label: "Psycholog Warszawa Targówek",
    url: "/psycholog-targowek/",
    isBlank: true,
  },
  {
    label: "Psycholog Legionowo",
    url: "/psycholog-legionowo/",
    isBlank: true,
  },
  {
    label: "Psycholog Otwock",
    url: "/psycholog-otwock/",
    isBlank: true,
  },
  {
    label: "Praca dla psychologa",
    url: "/praca/",
  },
];

const Summary = () => {
  return (
    <div className="footer-summary">
      <ul className="footer-summary__links">
        {links.map((link, index) => (
          <li key={index}>
            {link.isBlank ? (
              <a href={link.url} target="_blank" rel="noreferrer">
                {link.label}
              </a>
            ) : (
              <Link to={link.url}>{link.label}</Link>
            )}
          </li>
        ))}
      </ul>
      <div className="footer-summary__copy">
        <div className="row align-items-end">
          <div className="col-sm-7">
            <div className="footer-summary__copy-banner">
              <img
                src={require("assets/images/copyscape-banner.png").default}
                alt="PROTECTED BY COPYSCAPE"
              />
            </div>
            <div className="footer-summary__copy-description">
              <p>
                Wszystkie treści, materiały oraz elementy graficzne umieszczone
                w tym serwisie są własnością SPOKÓJ W GŁOWIE sp. z o.o.
              </p>
            </div>
          </div>
          <div className="col-sm-5 d-flex justify-content-sm-end">
            <p>
              <a href="https://adream.pl/" target="_blank" rel="noreferrer">
                Projekt i realizacja: ADream
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Summary;
